import { toLocalizedUrl } from 'tradera/utils/url';

/**
 * Hide location.reload to be able to stub it with sinon
 * see https://developer.mozilla.org/en-US/docs/Web/API/Location/reload
 */
export const reload = (force = false) => location.reload(force);

export const reloadLocalized = (code) =>
    (window.location.href = toLocalizedUrl(window.location.href, code));

// Export object for Sinon stubbing
export default {
    reload,
    reloadLocalized
};
